/**
 * 測定データ
 */
export default interface MeasurementData {
  /**
   * ホスト名（システム全体でユニーク。変更不可。半角英数記号）
   * HostName
   */
  hostName: string;
  /**
   * ポジション番号(0X+16進8桁)
   * PositionNo
   */
  positionNo: string;
  /**
   * 測定日時時刻
   * Meas_Time
   */
  time: string;
  /**
   * 項目種別
   * Item_Kind
   */
  itemKind?: number;
  /**
   * ステータス(0X+16進8桁)
   * Status
   */
  status?: string;
  /**
   * 項目名称
   * ItemName
   */
  itemName?: string;
  /**
   * 値
   * Val
   */
  value?: number;
  /**
   * 単位/動作名
   * Unit
   */
  unit?: string;
}

export function isMeasurementData(data: unknown): data is MeasurementData {
  const result = data as MeasurementData;
  return (
    result != null &&
    typeof result === 'object' &&
    typeof result.hostName === 'string' &&
    typeof result.positionNo === 'string' &&
    (result.time == null || typeof result.time === 'string') &&
    (result.itemKind == null || typeof result.itemKind === 'number') &&
    (result.status == null || typeof result.status === 'string') &&
    (result.itemName == null || typeof result.itemName === 'string') &&
    (result.value == null || typeof result.value === 'number') &&
    (result.unit == null || typeof result.unit === 'string')
  );
}
